// project import
import other, { getOtherMenu } from './other';
import pages, { getPagesMenu } from './pages';

// types
import type { User } from '@/types/auth';
import type { NavItemType } from '@/types';
import { isAdmin, isSilverStayUser, isSupervisor } from '@/utils/role';
import { ENABLED_WEEKEND_DISCHARGE_HOSPITALS } from '@/constant';
import { canShowSupervisorMeetingTranscription } from '@/utils/meeting-transcription/access';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
    items: [pages, other]
};

type MenuItemsOptions = {
    hospitalId?: string;
    hospitalName?: string;
    user?: User | null;
};

export const getMenuItems = ({ hospitalId, hospitalName, user }: MenuItemsOptions = {}): { items: NavItemType[] } => {
    const items: NavItemType[] = [];
    const hideWeekendHandoff = !ENABLED_WEEKEND_DISCHARGE_HOSPITALS.includes(String(hospitalName).trim().toLowerCase());
    const isUserSilverStay = isSilverStayUser(user);
    if (isAdmin(user)) {
        items.push(
            getPagesMenu({
                hospitalId,
                hideWeekendHandoff,
                showStaticSubscribers: true
            })
        );
    } else {
        const isUserSupervisor = isSupervisor(user);
        const isHospitalSupervisor = isUserSupervisor && !isUserSilverStay;
        items.push(
            getOtherMenu({
                hideWeekendHandoff,
                showMeetingView: isUserSupervisor,
                showMeetingTranscription: canShowSupervisorMeetingTranscription(user),
                showSupervisorScorecard: isHospitalSupervisor,
                showInsights: isHospitalSupervisor,
                showDartReport: isHospitalSupervisor,
                showStaticSubscribers: isUserSupervisor,
                isSilverStay: isUserSilverStay
            })
        );
    }

    return { items };
};

export default menuItems;
